// Third payty and libraries
import React from 'react'
import { Card, Button, Row, Col } from "react-bootstrap"

// component and constant
import { convertCurrency, convertPriceWithCommission, imageRender, numberFormat } from '../../helpers'
import { COLOR_APP } from '../../constants'

//  icons 
import { FaArrowRight } from 'react-icons/fa'
import moment from 'moment'

export default function StepOrderDetail({ setActiveTab, orderGroupData, shopRate }) {
    return (
        <Card style={{ boxShadow: 'none', background: '#ffffff' }}>
            <Card.Header className='d-flex justify-content-between align-items-start pb-0'>
                <Card.Title>
                    <p style={{ fontSize: 16, fontWeight: 'bold' }}>ເລກບິນ: {orderGroupData?.code}</p>
                    <p style={{ fontSize: 16, fontWeight: 'bold' }}>{moment(orderGroupData?.createdAt).format('DD/MM/YYYY HH:mm')}</p>
                </Card.Title>
                <Button variant={orderGroupData?.isPaymented ? "success" : "danger"} size="sm">
                    {orderGroupData?.isPaymented ? "ຈ່າຍແລ້ວ" : "ຍັງບໍຈ່າຍເງິນ"}
                </Button>
            </Card.Header>
            <Card.Body className='d-flex justify-content-center align-items-center flex-column'>

                {orderGroupData?.orders.map((item, index) => (
                    <div className='card-order' key={index}>
                        <div className='order-left'>
                            <img className='order-image' src={imageRender(item?.stock?.image)} alt='product-name' />
                            <div>
                                <h5 style={{ fontWeight: 'bold' }}>{item?.productName ?? "-"}</h5>
                                <p style={{ fontSize: 18 }}>{convertCurrency(item?.currency)}{numberFormat(item?.price) ?? 0} x {item?.amount ?? 0}</p>
                            </div>
                        </div>
                        <div className='order-right'>
                            <div></div>
                            <p style={{ fontSize: 18, }}>{convertCurrency(item?.currency)}{numberFormat(item?.totalPrice)} </p>
                        </div>
                    </div>
                ))}


                <div className="card-total-order">
                    <Row>
                        <Col md={4} sm={0}>ຍອດລວມ</Col>
                        <Col>
                            <div className='w-100 d-flex flex-column  justify-content-center align-items-end'>
                                <p>ສິນຄ້າ</p>
                                <p>ລວມເງິນກິບ</p>
                                <p>ລວມເງິນບາດ</p>
                                <p>ລວມເງິນໂດລາ</p>
                                <p style={{ fontWeight: 'bold', textAlign: 'right' }}>ຄ່າບໍລິການ</p>
                                <h4 style={{ fontWeight: 'bold', textAlign: 'right' }}>ຍອດເງິນທີ່ຕ້ອງຈ່າຍ</h4>
                            </div>
                        </Col>
                        <Col>
                            <div className='w-100 d-flex flex-column justify-content-center align-items-end'>
                                <p>{orderGroupData?.orders?.length ?? 0}</p>
                                <p>₭{numberFormat(orderGroupData?.totalPrice ?? 0)}</p>
                                <p>฿{numberFormat(orderGroupData?.sumPriceBaht ?? 0)}</p>
                                <p>${numberFormat(orderGroupData?.sumPriceUsd ?? 0)}</p>
                                <p style={{ fontWeight: 'bold', textAlign: 'right' }}>0</p>
                                <h4 style={{ fontWeight: 'bold', textAlign: 'right' }}>₭{numberFormat(convertPriceWithCommission(orderGroupData?.totalPrice ?? 0, orderGroupData?.sumPriceBaht ?? 0, orderGroupData?.sumPriceUsd ?? 0, 0, shopRate))}</h4>
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className='d-flex justify-content-between align-items-center w-100 pt-4'>
                    <p style={{ color: '#777777' }}>ເລດຮ້ານ: {shopRate?.baht ?? 0 + " ບາດ"}, {numberFormat(shopRate?.usd ?? 0) + " ໂດລາ"}</p>
                    <Button size='md' onClick={() => setActiveTab('add-address')} style={{ background: COLOR_APP, color: '#ffffff', border: 'none', minWidth: 100 }}>ກົດເພື່ອຊຳລະ <FaArrowRight /></Button>
                </div>
            </Card.Body>
        </Card>
    )
}
